import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_CONSULTA_POR_COSECHA } from '../../../../config/tables'

export default function DetalleConsultaPorCosechaView () {
  return <MuiTable id={TABLA_DETALLE_CONSULTA_POR_COSECHA} />
}
